import React from "react";
import { Alert } from "react-bootstrap";
import { useFormikContext } from "formik";
import MessageTextBox from "../../../pages/Campaigns/migrate/messages/MessageTextBox";
const MessageText = () => {
  const { values, setFieldValue, errors, touched, handleBlur } =
    useFormikContext();
  return (
    <div className="bg-white py-3 rounded-lg">
      <div className="px-4">
        <div className="text-xl font-bold text-gray-600">
          Mensaje (Fallback)
        </div>
        <Alert variant="warning" className="Notice">
          En caso de no poder enviar el mensaje RCS, se enviará el mensaje de
          fallback como un SMS.
        </Alert>
        <MessageTextBox
          value={values.fallback}
          onChange={(e) => setFieldValue("fallback", e.target.value)}
          name="fallback"
          onBlur={handleBlur}
          isError={errors && errors.fallback}
          errorMsg={errors && touched ? errors.fallback : ""}
          template={values.template_fallback}
          fieldsInfo={values.fieldsInfo}
        />
      </div>
    </div>
  );
};

export default MessageText;
